module.exports = __webpack_public_path__ + "img/message-captions.e261aec4.svg";